var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getLoginType, getUserData } from '../logic/auth';
import { canUseDOM } from 'exenv';
import { track } from '@food/tracking';
import { authTrackOverride } from './track';
/**
 * Funzione per capire a partire dai dati di localStorage se siamo in un caso di rinnovo o di login
 */
export var isRenew = function () { return !!(getUserData() && getLoginType()); };
/**
 * Funzione per formattare in modo umano gli emailDomain
 * @param i - FIXME - Use proper types
 */
export var emailDomainLabel = function (i) {
    var str = ['Cname', 'CGname', 'Sname', 'Rname'].reduce(function (p, c) { return (i[c] && i[c].length > 0 ? i[c] : p); }, '');
    if (i.CountryName) {
        str += ' - ' + i.CountryName;
    }
    if (i.Tname) {
        str += " (Team " + i.Tname + ")";
    }
    return str;
};
// FIXME - Use proper types
export var emailDomainType = function (i) {
    var labels = ['Company', 'Company Group', 'Service', 'Retailer'];
    return ['Cname', 'CGname', 'Sname', 'Rname'].reduce(function (p, c, k) { return (i[c] && i[c].length > 0 ? labels[k] : p); }, '');
};
var dangerousRequestKeys = ['password', 'grantToken', 'cryptoRenewToken'];
var cleanServerRequest = function (request) {
    var cleanRequest = __assign({}, request);
    dangerousRequestKeys.forEach(function (key) {
        if (key in cleanRequest) {
            cleanRequest[key] = '*****';
        }
    });
    if (request.options && request.options.workEmailVerifyToken) {
        cleanRequest.options = __assign(__assign({}, request.options), { workEmailVerifyToken: '*****' });
    }
    return cleanRequest;
};
// Keep possible string explicit type-wise because compiler have to check '*****' is a valid value for field
var dangerousResponseKeys = ['cryptoRenewToken'];
var cleanServerResponse = function (response) {
    var cleanResponse = __assign({}, response);
    dangerousResponseKeys.forEach(function (key) {
        if (key in cleanResponse) {
            cleanResponse[key] = '*****';
        }
    });
    if (cleanResponse.choices && cleanResponse.key === 'options.tosApproved') {
        cleanResponse.choices = cleanResponse.choices.map(function (choice) { return choice.id; });
    }
    if (cleanResponse.userAuth && cleanResponse.userAuth.authorization) {
        cleanResponse.userAuth = __assign(__assign({}, cleanResponse.userAuth), { authorization: '*****' });
    }
    return cleanResponse;
};
export function httpApiCall(body, endpoint, targetSite) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    fetch(endpoint, {
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                            'X-Target-Site': targetSite,
                        },
                        method: 'POST',
                        body: JSON.stringify(body),
                    })
                        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
                        var res;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, response.json()];
                                case 1:
                                    res = _a.sent();
                                    track(__assign(__assign({}, authTrackOverride), { action: {
                                            type: 'auth_server_request',
                                            request: cleanServerRequest(body),
                                            response: {
                                                json: cleanServerResponse(res),
                                                code: response.status,
                                            },
                                        } }));
                                    resolve(res);
                                    return [2 /*return*/];
                            }
                        });
                    }); })
                        .catch(function (err) {
                        resolve({
                            status: 500,
                            success: false,
                            type: '',
                            message: err.message,
                        });
                    });
                })];
        });
    });
}
export function validateEmail(email) {
    if (!email || email.length === 0) {
        return false;
    }
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email.trim().toLowerCase());
}
export var hasUserAuthData = function (r) {
    return r &&
        r.payload &&
        r.payload.userAuth &&
        r.payload.userAuth.auth &&
        r.payload.userAuth.auth.user;
};
export var hasEmailDomainData = function (r) {
    return r && r.payload && r.payload.EmailDomainRow;
};
export var addUserKey = function (keys) {
    if (!canUseDOM) {
        return;
    }
    var key = '@food/userKeys';
    var val = localStorage.getItem(key);
    var parsed = val ? JSON.parse(val) : [];
    var newParsed = parsed
        .concat(keys)
        .filter(function (key, index, arr) {
        return arr.indexOf(key) === index;
    });
    localStorage.setItem(key, JSON.stringify(newParsed));
};
/**
 * @description Funzione per estrarre la work email dalla risposta del server
 * @param r: IWrappedResponse
 * @return string
 */
export var extractWorkEmail = function (r) {
    return r && r.payload && r.payload.workEmail;
};
export var cleanUserData = function (userAuthData) { return (__assign(__assign({}, userAuthData), { authorization: '*****' })); };
//# sourceMappingURL=misc.js.map